import React, {useEffect} from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default function Contact() {
    useEffect(() => {
        AOS.init({duration:1300})
    }, [])
    
    return (
        <section className="contact-area page-section scroll-content" id="contact">
            <div className="custom-container">
                <div className="contact-content content-width">
                    <div className="section-header">
                        <h4 className="subtitle scroll-animation" data-aos='fade-up'>
                            <i className="las la-envelope"></i> contact
                        </h4>
                        <h1 className="scroll-animation" data-aos='fade-up'>Let's Connect</h1>
                    </div>
                    
                    <div className="contact-items">
                        <div className="contact-item scroll-animation" data-aos='fade-up'>
                            <div className="contact-info">
                                <h3>Email</h3>
                                <a href="mailto:brijesh.chavda@gmail.com" className="contact-link">
                                    <i className="las la-envelope"></i>
                                    <span>brijesh.chavda@gmail.com</span>
                                </a>
                            </div>
                        </div>

                        <div className="contact-item scroll-animation" data-aos='fade-up'>
                            <div className="contact-info">
                                <h3>Professional Network</h3>
                                <a href="https://www.linkedin.com/in/brijeshchavda/" 
                                   target="_blank" 
                                   rel="noopener noreferrer"
                                   className="contact-link">
                                    <i className="lab la-linkedin"></i>
                                    <span>CONNECT ON LINKEDIN</span>
                                </a>
                            </div>
                        </div>

                        <div className="contact-item scroll-animation" data-aos='fade-up'>
                            <div className="contact-info">
                                <h3>Location</h3>
                                <div className="location-info">
                                    <i className="las la-map-marker"></i>
                                    <div>
                                        <p>Bay area, California</p>
                                        <p>United States</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
